export default __webpack_public_path__ + "static/Michelin-e5ff6580c0d11ac1b3f91012b753fb19.jpg";